import useGetDHTOvertimePerDriver from '../../../API/hooks/drivers/useGetDHTOvertimePerDriver';
import Tags from '../../../components/common/Tags';
import { convertMsToHours } from '../../../utils/dateUtils';

type Props = {
  driverId: string;
  fleetId: string;
  level: number,
};

function OvertimeTag({ driverId, fleetId, level }: Props): JSX.Element {
  const {
    tripInSec, dayInSec, weekInSec, monthInSec,
  } = useGetDHTOvertimePerDriver(fleetId, driverId);
  let label = '';

  if (tripInSec < 0 || dayInSec < 0 || weekInSec < 0 || monthInSec < 0) {
    return (
      <Tags.Label
        label="Alert was created before limit changing"
      />
    );
  }

  switch (level) {
    case 1:
      label = `Over ${convertMsToHours(tripInSec)}h during the trip`;
      break;
    case 2:
      label = `Over ${convertMsToHours(dayInSec)}h during the day`;
      break;
    case 3:
      label = `Over ${convertMsToHours(weekInSec)}h during the week`;
      break;
    case 4:
      label = `Over ${convertMsToHours(monthInSec)}h during the month`;
      break;
    default:
      label = 'Unknown event level';
  }

  return (
    <Tags.Label
      label={label}
    />
  );
}

export default OvertimeTag;
